import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonText } from '@ionic/angular/standalone';
import { PuzzleHelpDialogInjectableInterface } from '../../shared-module/puzzle-help-dialog/puzzle-help-dialog-injectable.interface';
import { HelperFunctionsService } from '../../shared-module/helpers/helper-functions.service';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-app-image-puzzle-help',
  templateUrl: './image-puzzle-help.component.html',
  styleUrls: ['./image-puzzle-help.component.scss'],
  standalone: true,
  imports: [CommonModule, IonText, TranslateModule],
})
export class ImagePuzzleHelpComponent implements PuzzleHelpDialogInjectableInterface {
  data: any;
  isMobile: boolean;
  translationKey: string;

  constructor(private helperFunctionService: HelperFunctionsService, private framework: PuzzleFrameworkService) {
    this.isMobile = helperFunctionService.isMobileDevice();
    this.translationKey = this.framework.getTranslationKey();
  }

  setData(data: any): void {
    this.data = data;
  }
}
